import Breadcrumb from '../../core/components/UI/Breadcrumb'
import FormCreateMineral from '../components/mineral-create-page/FormCreateMineral'
const links = [
  {
    id: 1,
    label: 'المعادن',
    isActive: false,
    to: '/minerals',
  },
  {
    id: 2,
    label: 'إنشاء معدن',
    isActive: true,
    to: '/minerals/create',
  },
]
export default function MineralCreatePage() {
  return (
    <>
      <Breadcrumb links={links} />
      <div className="border-2 border-muted-500 bg-white p-2">
        <FormCreateMineral />
      </div>
    </>
  )
}
